import React from 'react';
import classes from './Divider.scss';

export default () => (
  <div className={classes['divider']}></div>
);
